import Vue from "vue";
import Router from "vue-router";
import Impressum from "./pages/Impressum.vue";
import Home from "./pages/Home.vue";
import Datenschutz from "./pages/Datenschutz.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import ContactUs from "./pages/ContactUs.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/Home"
    },
    {
      path: "/Home",
      name: "Home",
      components: {default: Home, header: MainNavbar, footer: MainFooter},
      props: {footer: {backgroundColor: 'black'}}
    },
    {
      path: "/Impressum",
      name: "Impressum",
      components: {default: Impressum, header: MainNavbar, footer: MainFooter},
      props: {footer: {backgroundColor: 'black'}}
    },
    {
      path: "/Datenschutz",
      name: "Datenschutz",
      components: {default: Datenschutz, header: MainNavbar, footer: MainFooter},
      props: {footer: {backgroundColor: 'black'}}
    },
    {
      path: "/contact",
      name: "contact",
      components: {default: ContactUs, header: MainNavbar, footer: MainFooter},
      props: {footer: {backgroundColor: 'black'}}
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});

export default router;
